import type {SafeHTMLString} from '@github-ui/safe-html'
import {VerifiedHTMLDiv} from '@github-ui/safe-html/VerifiedHTML'
import {type Icon, AlertFillIcon, CheckCircleFillIcon, XCircleFillIcon} from '@primer/octicons-react'
import {Label} from '@primer/react'
import type {FC} from 'react'
import type {MergeReadiness} from './types'

const ASSESSMENT_LABELS: Record<
  MergeReadiness,
  {label: string; variant: 'success' | 'danger' | 'attention'; icon: Icon}
> = {
  ready: {label: 'Ready to merge', variant: 'success', icon: CheckCircleFillIcon},
  needs_changes: {label: 'Changes needed', variant: 'danger', icon: XCircleFillIcon},
  too_complex: {label: 'Human review recommended', variant: 'attention', icon: AlertFillIcon},
}

interface FindingsSummaryProps {
  mergeReadiness: MergeReadiness | null
  overviewSummary?: string | null
}

export const FindingsSummary: FC<FindingsSummaryProps> = ({mergeReadiness, overviewSummary}) => {
  const assessment = mergeReadiness ? ASSESSMENT_LABELS[mergeReadiness] : null

  if (!assessment && !overviewSummary) return null

  return (
    <>
      <div className="d-flex flex-items-center gap-2 tmp-mb-3">
        <h2 className="f4 fgColor-muted">Summary</h2>
        {assessment && (
          <Label variant={assessment.variant}>
            <span className="d-flex flex-items-center gap-1">
              <assessment.icon size={16} />
              {assessment.label}
            </span>
          </Label>
        )}
      </div>
      {overviewSummary && (
        <VerifiedHTMLDiv
          // eslint-disable-next-line @github-ui/github-monorepo/no-cast-as-safe-html-string -- sanitized on the backend
          html={overviewSummary as SafeHTMLString}
          className="tmp-p-3 tmp-mb-3 border rounded-3 markdown-body comment-body"
        />
      )}
    </>
  )
}
